import React from "react";
import UserOpsModalShell from "./UserOpsModalShell";
import RewardAdminContent from "../../../pages/RewardAdminContent";

export default function UserRewardModal({ open, user, theme, onClose, onSuccess }) {
  if (!user) return null;

  return (
    <UserOpsModalShell
      open={open}
      onClose={onClose}
      eyebrow="Treasury desk"
      title="Issue reward"
      tone="reward"
      user={user}
      ariaLabel="Reward user"
    >
      <RewardAdminContent
        theme={theme}
        compact
        userName={user.name}
        defaultInviteCode={user.inviteCode || ""}
        onSuccess={onSuccess}
      />
    </UserOpsModalShell>
  );
}
